import { Component } from "@/types"
import { cx } from "@/utils/cx"
import { QuoteBlock } from "./QuoteBlock/QuoteBlock"
import { ContentBlock } from "./ContentBlock/ContentBlock"
import { Grid } from "@/ui/atoms/layout/Grid"
import { Stack } from "@/ui/atoms/layout/Stack"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { Image } from "@/ui/atoms/media/Image"

export const COMPONENT_NAME = "courseFeatureSection"

export const presets = {}

export interface Props extends Component {
  contentOvertitle: string
  contentTitle: string
  contentDescription: string
  contentSource?: string
  contentImage: string
  quoteOneContent: string
  quoteOneAuthor: string
  quoteOneRole: string
  quoteTwoContent: string
  quoteTwoAuthor: string
  quoteTwoRole: string
  flip?: boolean
}

export function CourseFeatureSection({
  contentOvertitle,
  contentTitle,
  contentDescription,
  contentSource,
  contentImage,
  quoteOneContent,
  quoteOneAuthor,
  quoteOneRole,
  quoteTwoContent,
  quoteTwoAuthor,
  quoteTwoRole,
  className,
  testId = COMPONENT_NAME,
  flip = false,
}: Props) {
  return (
    <Stack className={cx(`gap-6`, className)} testId={testId}>
      <MarketingSection removeYPadding>
        <Grid className="gap-6 md:gap-12">
          <ContentBlock
            overtitle={contentOvertitle}
            title={contentTitle}
            description={contentDescription}
            source={contentSource}
            className={cx(`col-span-full md:col-span-5 row-start-1`, flip && "md:col-start-7")}
          />
          <div
            className={cx(
              `col-span-full md:row-start-1 md:col-span-6 md:pl-2`,
              !flip && "md:col-start-7",
            )}
          >
            <Image src={contentImage} alt="" width={1172} height={720} />
          </div>
        </Grid>
      </MarketingSection>
      <MarketingSection removeYPadding className="overflow-x-auto max-w-[100vw] lg:max-w-none">
        <div className={cx("flex gap-6 items-start")}>
          {flip && <div className={cx(`hidden lg:w-1/3 lg:block`)}></div>}
          <QuoteBlock
            quote={quoteOneContent}
            author={quoteOneAuthor}
            role={quoteOneRole}
            className="w-[80vw] md:w-1/2 lg:w-1/3 shrink-0"
          />
          <QuoteBlock
            quote={quoteTwoContent}
            author={quoteTwoAuthor}
            role={quoteTwoRole}
            className="w-[80vw] md:w-1/2 lg:w-1/3 shrink-0"
          />
          <div className="overflow-bookend lg:hidden" />
        </div>
      </MarketingSection>
    </Stack>
  )
}
